/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type { ITradeManager, ITradeManagerInterface } from "../ITradeManager";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "addedMargin",
        type: "uint256",
      },
    ],
    name: "MarginAddedToPosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "removedMargin",
        type: "uint256",
      },
    ],
    name: "MarginRemovedFromPosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "PositionClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "addedMargin",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "addedLeverage",
        type: "uint256",
      },
    ],
    name: "PositionExtended",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "targetLeverage",
        type: "uint256",
      },
    ],
    name: "PositionExtendedToLeverage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "PositionLiquidated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "PositionOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proportion",
        type: "uint256",
      },
    ],
    name: "PositionPartiallyClosed",
    type: "event",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "addedMargin",
            type: "uint256",
          },
        ],
        internalType: "struct AddMarginToPositionParams",
        name: "params",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "minPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "maxPrice",
            type: "int256",
          },
        ],
        internalType: "struct Constraints",
        name: "constraints",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData",
        type: "tuple[]",
      },
    ],
    name: "addMarginToPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tradePairs",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "positionIds",
        type: "uint256[][]",
      },
      {
        internalType: "bool",
        name: "allowRevert",
        type: "bool",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData",
        type: "tuple[]",
      },
    ],
    name: "batchLiquidatePositions",
    outputs: [
      {
        internalType: "bool[][]",
        name: "didLiquidate",
        type: "bool[][]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tradePairs",
        type: "address[]",
      },
      {
        internalType: "uint256[][]",
        name: "positionIds",
        type: "uint256[][]",
      },
    ],
    name: "canLiquidatePositions",
    outputs: [
      {
        internalType: "bool[][]",
        name: "canLiquidate",
        type: "bool[][]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
        ],
        internalType: "struct ClosePositionParams",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "minPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "maxPrice",
            type: "int256",
          },
        ],
        internalType: "struct Constraints",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "",
        type: "tuple[]",
      },
    ],
    name: "closePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    name: "detailsOfPosition",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "margin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "volume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "assetAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isShort",
            type: "bool",
          },
          {
            internalType: "int256",
            name: "entryPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "markPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "bankruptcyPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "equity",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "PnL",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "totalFeeAmount",
            type: "int256",
          },
          {
            internalType: "uint256",
            name: "currentVolume",
            type: "uint256",
          },
        ],
        internalType: "struct PositionDetails",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "addedMargin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "addedLeverage",
            type: "uint256",
          },
        ],
        internalType: "struct ExtendPositionParams",
        name: "params",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "minPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "maxPrice",
            type: "int256",
          },
        ],
        internalType: "struct Constraints",
        name: "constraints",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData",
        type: "tuple[]",
      },
    ],
    name: "extendPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "targetLeverage",
            type: "uint256",
          },
        ],
        internalType: "struct ExtendPositionToLeverageParams",
        name: "params",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "minPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "maxPrice",
            type: "int256",
          },
        ],
        internalType: "struct Constraints",
        name: "constraints",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData",
        type: "tuple[]",
      },
    ],
    name: "extendPositionToLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
    ],
    name: "getCurrentFundingFeeRates",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData",
        type: "tuple[]",
      },
    ],
    name: "liquidatePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "margin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isShort",
            type: "bool",
          },
          {
            internalType: "address",
            name: "referrer",
            type: "address",
          },
          {
            internalType: "address",
            name: "whitelabelAddress",
            type: "address",
          },
        ],
        internalType: "struct OpenPositionParams",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "minPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "maxPrice",
            type: "int256",
          },
        ],
        internalType: "struct Constraints",
        name: "",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "",
        type: "tuple[]",
      },
    ],
    name: "openPosition",
    outputs: [
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "proportion",
            type: "uint256",
          },
        ],
        internalType: "struct PartiallyClosePositionParams",
        name: "params",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "minPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "maxPrice",
            type: "int256",
          },
        ],
        internalType: "struct Constraints",
        name: "constraints",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData",
        type: "tuple[]",
      },
    ],
    name: "partiallyClosePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    name: "positionIsLiquidatable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "tradePair",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "positionId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "removedMargin",
            type: "uint256",
          },
        ],
        internalType: "struct RemoveMarginFromPositionParams",
        name: "params",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "deadline",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "minPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "maxPrice",
            type: "int256",
          },
        ],
        internalType: "struct Constraints",
        name: "constraints",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "updatableContract",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct UpdateData[]",
        name: "updateData",
        type: "tuple[]",
      },
    ],
    name: "removeMarginFromPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tradePair_",
        type: "address",
      },
    ],
    name: "totalSizeLimitOfTradePair",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class ITradeManager__factory {
  static readonly abi = _abi;
  static createInterface(): ITradeManagerInterface {
    return new utils.Interface(_abi) as ITradeManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITradeManager {
    return new Contract(address, _abi, signerOrProvider) as ITradeManager;
  }
}
